// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HTF3","colMin":"styles_colMin__1yWHo"};